import { render, staticRenderFns } from "./requisition-type.vue?vue&type=template&id=59dadc2c&scoped=true&"
import script from "./requisition-type.vue?vue&type=script&lang=js&"
export * from "./requisition-type.vue?vue&type=script&lang=js&"
import style0 from "./requisition-type.vue?vue&type=style&index=0&id=59dadc2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dadc2c",
  null
  
)

export default component.exports